import { DocumentType } from 'src/models/enums/DocumentType.enum'
import { SupplementalDocumentLookupSummary } from './SupplementalDocumentLookupSummary'

export interface ISupplementalDocumentationDTO {
  documentType: DocumentType | undefined
  patientId: string | undefined
  episodeOfCareId: string | undefined
  cms1500Id: string | undefined
  patientFirstName: string | undefined
  patientLastName: string | undefined
  patientDOB: Date | undefined
  freeformAddress: string | undefined
  dateOfService: Date | undefined
  eocLegacy: string | undefined
  bodyPart: string | undefined
  takeoverOfCareDate: Date | undefined
  mmiDate: Date | undefined
  attentionInformation: string | undefined
  objectiveContactInformation: string | undefined
  claimDenialReasons: SupplementalDocumentLookupSummary[] | undefined
}

export class SupplementalDocumentationDTO implements ISupplementalDocumentationDTO {
  public documentType: DocumentType | undefined
  public patientId: string | undefined
  public episodeOfCareId: string | undefined
  public cms1500Id: string | undefined
  public patientFirstName: string | undefined
  public patientLastName: string | undefined
  public patientDOB: Date | undefined
  public freeformAddress: string | undefined
  public dateOfService: Date | undefined
  public eocLegacy: string | undefined
  public bodyPart: string | undefined
  public takeoverOfCareDate: Date | undefined
  public mmiDate: Date | undefined
  public attentionInformation: string | undefined
  public objectiveContactInformation: string | undefined
  public claimDenialReasons: SupplementalDocumentLookupSummary[] | undefined
}
